import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from '@vinnova/auth';
import { ChatbotService } from '@vinnova/chatbot';
import { EtjansterSites } from '@vinnova/e-tjanster';
import { take } from 'rxjs';
import { environment } from '../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent implements OnInit {
  hasError = false;
  isProduction: boolean;
  hasValidAccount: boolean;
  showChatbot = false;

  EtjansterSites = EtjansterSites;

  constructor(
    private authService: AuthService,
    private chatbotService: ChatbotService,
  ) {}

  ngOnInit() {
    this.isProduction = environment.production;
    this.authService
      .hasValidAccountAndActiveCookie()
      .pipe(take(1))
      .subscribe((hasValidAccountAndActiveCookie) => {
        this.hasValidAccount = hasValidAccountAndActiveCookie;
      });

    this.chatbotService.isAvailable$
      .pipe(untilDestroyed(this))
      .subscribe((isAvailable) => {
        this.showChatbot = isAvailable;
      });
  }
}
